var DFTlrd = DFTlrd || {};

DFTlrd.PlatinaGoldSponsorSwiper = function() {

    var _swiper;

    var _init = function() {
        const $swiper = $('.swiper--platina-gold-sponsors');
        _swiper = new Swiper($swiper[0], {
            speed: 3000,
            loop: true,
            autoplay : {
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                delay: 1000
            },
            slidesPerView: 1,
            spaceBetween: 0,
            on: {
                afterInit: function(swiper){
                    $swiper
                        .find('[data-anim-fx]')
                        .each(function() {
                            let el = $(this);
                            ValueJS.AnimateCSS.animate(el);
                        });
                },
            }
        });
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    DFTlrd.PlatinaGoldSponsorSwiper.init();
});
